import { useTranslation } from '@atlas/core';

import { snakeCase } from 'common/utils/snakeCase';

const PARAMS_REPLACE_RX = /\[(\w+)\]/g;

const useTranslate = (message, params) => {
  const translation = useTranslation();

  return (message, params) => {
    if (!message || !translation) {
      return '';
    }
    const messageKey = snakeCase(message).toLowerCase();
    const messageParams = params || {};
    const translatedMessage = translation[messageKey] || `#${messageKey}`;

    return translatedMessage.replace(PARAMS_REPLACE_RX, (value, match) => {
      if (!messageParams[match]) {
        return `[${match}]`;
      }
      return messageParams[match];
    });
  };
};

export default useTranslate;
